// Pure builders for optimistic inbox messages. No MobX, no JSX — unit-testable.
// An optimistic message is shaped like a real message so the inbox renderer can
// display it immediately, plus `pending`/`failed` flags and a `_retry`
// descriptor that lets the component re-send any of the three paths uniformly.

export function buildOptimisticMessage({ kind, body, fromUser, fromName, toUserUuidv4, tempUuid, nowIso, images = [], replyToUuidv4 = null }) {
    const isBroadcast = kind === 'broadcast';
    return {
        uuidv4: tempUuid,
        id: undefined,
        fromUser,
        toUser: isBroadcast ? '@all' : toUserUuidv4,
        fromName: isBroadcast ? fromName : undefined,
        body,
        images,
        replyToUuidv4,
        likes: [],
        sentDate: nowIso,
        createdDate: nowIso,
        isBroadcast: isBroadcast ? 1 : 0,
        pending: true,
        failed: false,
        _retry: { kind, toUserUuidv4, body, images, replyToUuidv4 },
    };
}

export function buildEditPatch({ body, editUuidv4, toUserUuidv4 }) {
    return {
        body,
        pending: true,
        failed: false,
        _retry: { kind: 'edit', toUserUuidv4, body, editUuidv4 },
    };
}

// Return a NEW array with the matching message shallow-merged with `patch`.
// Never mutates the input (MobX: callers feed the result to updateKeyValue).
export function applyMessagePatch(messages, uuidv4, patch) {
    return messages.map(m => (m.uuidv4 === uuidv4 ? { ...m, ...patch } : m));
}
